import { render, staticRenderFns } from "./detailDrvEnd.vue?vue&type=template&id=2b45eb3f&scoped=true"
import script from "./detailDrvEnd.vue?vue&type=script&lang=js"
export * from "./detailDrvEnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b45eb3f",
  null
  
)

export default component.exports